import appLocaleData from 'react-intl/locale-data/es';
import esMessages from '../locales/es_ES.json';

const esLang = {
  messages: { ...esMessages },
  locale: 'es-ES',
  data: appLocaleData,
};
export default esLang;



// WEBPACK FOOTER //
// ./lngProvider/entries/es_ES.js